export default __webpack_public_path__ + "bbfec21b04ece3fafaf542dffb8e86df.svg";